import { RootState } from "@/store/store";
import { widgetSetupWidgetNameSelector } from "@/store/dashboards/selectors/setups/common/widgetSetupWidgetNameSelector";
import { normalizedCostWidgetSetupIdSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupIdSelector";
import { normalizedCostWidgetSetupViewIdSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupViewIdSelector";
import { normalizedCostWidgetEditChangesExistSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetEditChangesExistSelector";

export const normalizedCostWidgetSubmitButtonDisabledSelector = (
  state: RootState,
) => {
  const editDisabledByChange =
    normalizedCostWidgetEditChangesExistSelector(state);
  const name = widgetSetupWidgetNameSelector(state);
  const id = normalizedCostWidgetSetupIdSelector(state);
  const viewId = normalizedCostWidgetSetupViewIdSelector(state);

  return (id && !editDisabledByChange) || !name || !viewId;
};
